<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      max-width="1000px"
      scrollable
      @keydown="executeCloseModalUploadDocument"
      @click:outside="executeCloseModalUploadDocument"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5>
            {{
              currentDocument
                ? "Actualizar Documento"
                : "Cargar Nuevo Documento"
            }}
          </h5>
        </div>
        <hr />
        <v-card-text>
          <v-container class="">
            <v-form @submit.prevent="sendUploadDocument">
              <v-row align-content="center" class="mt-2">
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  class="pt-0"
                  v-if="!currentDocument"
                >
                  <label class="mt-1"> Carpeta Contenedora * </label>
                  <v-autocomplete
                    :disabled="disabledDocumentRequired"
                    :key="folderIdKey"
                    @change="searchFoldersDocumentsTypes(null)"
                    placeholder="Selecciona la Carpeta Contenedora"
                    v-model="$v.form.folder_id.$model"
                    :error="$v.form.folder_id.$invalid && submitUpload"
                    :error-messages="
                      $v.form.folder_id.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                    :items="foldersFromProjectOrPresale"
                    item-text="name"
                    item-value="name"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  class="pt-0"
                  v-if="!currentDocument"
                >
                  <label class="mt-1"> Área Responsable * </label>
                  <v-autocomplete
                    :key="assignAreaNameKey"
                    :disabled="disabledDocumentRequired"
                    no-data-text="Sin Áreas Responsables"
                    placeholder="Selecciona el Área Responsable"
                    v-model="$v.form.assign_area_name.$model"
                    :error="$v.form.assign_area_name.$invalid && submitUpload"
                    :error-messages="
                      $v.form.assign_area_name.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                    :items="assignedAreas"
                    item-text="name"
                    item-value="name"
                  ></v-autocomplete>
                </v-col>
                <!-- <section class="d-flex justify-space-between">
                  <div
                    class="px-3 mr-3 mb-5 border border-primary border-2 rounded"
                  >
                    <small class="text-info text-justify border-primary">
                      <b>TIP:</b> Si el nombre del documento, que buscas no
                      existe, pulsa el botón <b>Crear Nombre del Documento</b> y
                      selecciona la Carpeta Contenedora y el Área Responsable.
                    </small>
                    <br />
                    <p
                      class="mt-3 mb-0 text-success"
                      v-if="searchNameDocument && !form.folder_document_type_id"
                    >
                      Nombre a agregar: {{ searchNameDocument }}
                    </p>
                  </div>
                  <div>
                    <v-btn
                      color="primary"
                      small
                      class="px-3"
                      :disabled="
                        !form.folder_id ||
                        !form.assign_area_name ||
                        !searchNameDocument
                      "
                      @click="createNameDocument()"
                    >
                      <v-icon small class="mr-2"> mdi-plus </v-icon>
                      <small> Crear Nombre de Documento </small>
                    </v-btn>
                  </div>
                </section> -->

                 <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  class="pt-0"
                  v-if="!currentDocument"
                > 
                  <label class="mt-1 mb-0 pb-0"> Nombre de Documento * </label>
                  <div
                    class="d-flex align-items-center"
                    v-if="!currentDocument && !disabledDocumentRequired"
                  >
                    <span
                      class="v-label mt-4 mr-3"
                      :class="{
                        'text-success': !form.type_name_document,
                      }"
                      >Listado</span
                    >
                    <v-switch
                      class="mt-3"
                      hide-details
                      :class="{
                        'custom-switch': !form.type_name_document,
                      }"
                      v-model="form.type_name_document"
                      inset
                    >
                      <template v-slot:label>
                        <span
                          class="mt-2"
                          :class="{
                            'text-primary': form.type_name_document,
                          }"
                        >
                          Documento Adicional
                        </span>
                      </template>
                    </v-switch>
                  </div>
                </v-col>
                <v-col cols="12" md="12" sm="12" class="pt-0">
                 <label class="mb-2 mt-1">Nombre *</label>
                  <v-autocomplete
                    class="mt-3"
                    v-if="!form.type_name_document"
                    :key="folderDocumentTypeIdKey"
                    :disabled="!form.folder_id || disabledDocumentRequired"
                    placeholder="Selecciona el Nombre de Documento"
                    v-model="$v.form.folder_document_type_id.$model"
                    :error="
                      $v.form.folder_document_type_id.$invalid && submitUpload
                    "
                    :error-messages="
                      $v.form.folder_document_type_id.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                    :items="filteredFoldersDocumentsTypes"
                    @update:search-input="
                      searchFoldersDocumentsTypes(
                        $event,
                        form.folder_document_type_id,
                        false
                      )
                    "
                    no-data-text="Sin Nombres de Documentos Disponibles"
                    item-text="name"
                    item-value="id"
                  ></v-autocomplete>
                  <section class="mt-3" v-show="form.type_name_document">
                    <v-text-field
                      placeholder="Ingresa el Nombre que tendrá este Documento"
                      v-model="$v.form.name_document_provisional.$model"
                      :error="
                        $v.form.name_document_provisional.$invalid &&
                          submitUpload
                      "
                      :error-messages="
                        $v.form.name_document_provisional.$invalid &&
                        submitUpload
                          ? 'Este campo es requerido'
                          : null
                      "
                    ></v-text-field>
                  </section>
                </v-col>
                <v-col cols="12" md="7" sm="12" class="pt-0">
                  <label for="document"> Documento * </label>
                  <v-file-input
                    placeholder="Selecciona el Documento"
                    v-model="$v.form.file.$model"
                    prepend-icon="mdi-paperclip"
                    :accept="acceptedFormatsForDocument"
                    :error="$v.form.file.$invalid && submitUpload"
                    :error-messages="
                      $v.form.file.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                  ></v-file-input>
                </v-col>
                <v-col cols="12" md="5" sm="12" align-self="center">
                  <div class="d-flex align-items center">
                    <v-btn
                      @click="openModalFilesDrive"
                      color="primary"
                      outlined
                      class="mx-2"
                      small
                    >
                      <img
                        width="20px"
                        class="mr-2"
                        src="@/assets/images/google-drive.svg"
                        alt="Google Drive"
                      />
                      <small>
                        Cargar desde Drive
                      </small>
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" md="12" sm="12" class="pt-0">
                  <label for="document"> Comentario </label>
                  <v-text-field
                    placeholder="Ingresa el Comentario"
                    v-model="form.comment"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" sm="12" class="pt-0" v-if="isSelectedDocumentDateValidable">
                  <label for="expiration_date"> Fecha de Vencimiento * </label>
                  <v-menu
                    ref="menuDate"
                    v-model="menuDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.expiration_date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        placeholder="Selecciona la fecha de vencimiento"
                        :error="$v.form.expiration_date.$invalid && submitUpload"
                        :error-messages="
                          $v.form.expiration_date.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.expiration_date"
                      @input="menuDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalUploadDocument"
          >
            <small> Cancelar </small>
          </v-btn>
          <v-btn
            @click="
              form.type_name_document
                ? createNameDocumentProvisional()
                : currentDocument
                ? updateDocument()
                : sendUploadDocument()
            "
            :color="currentDocument ? 'warning' : 'primary'"
            :loading="loading"
            :disabled="loading"
            small
            class="float-right"
          >
            {{ currentDocument ? "Actualizar Documento" : "Cargar Documento" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <modal-files-google-drive
      ref="modalFilesGoogleDrive"
      :modalAction="dialogGoogleDrive"
      :closeModalFilesGoogleDrive="closeModalFilesGoogleDrive"
      @fileDownload="setFileDonwloadDrive"
    ></modal-files-google-drive>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { required } from "vuelidate/lib/validators";
import swal2 from "sweetalert2";
import ModalFilesGoogleDrive from "./ModalFilesGoogleDrive.vue";
import { renameAndReturnNewFile } from "@/helpers/common";
export default {
  components: { ModalFilesGoogleDrive },
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalUploadDocument: {
      type: Function,
      default: () => {},
    },
    isPresale: {
      type: Boolean,
      default: false,
    },
    isProject: {
      type: Boolean,
      default: false,
    },
    currentDocument: {
      default: null,
    },
    
  },
  data() {
    return {
      is_cubicacion: false,
      dialogGoogleDrive: false,
      accessTokenGoogleDrive: localStorage.getItem("access_token_google_drive"),
      acceptedFormats: [
        ".png",
        ".jpg",
        ".jpeg",
        ".bmp",
        ".txt",
        ".doc",
        ".docx",
        ".xls",
        ".xlsx",
        ".pdf",
        ".ppt",
        ".pptx",
        ".mp4",
        ".mov",
        ".avi",
        ".dwg",
        ".kmz",
      ],
      // Only Formats for cubication
      acceptedCubage: [
        ".csv",
        ".xls",
        ".xlsx",
      ],
      loading: false,
      loadingFolders: false,
      debounce: null,
      debounceTime: 500,
      form: {
        folder_id: null,
        assign_area_name: null,
        folder_document_type_id: null,
        comment: "",
        file: null,
        is_cubicacion: false,
        type_name_document: null, //type_name_document: false,
        name_document_provisional: "",
        expiration_date: null,
      },
      disabledDocumentRequired: false,
      submitUpload: false,
      searchNameDocument: "",
      folderIdKey: 100,
      assignAreaNameKey: 101,
      folderDocumentTypeIdKey: 102,
      menuDate: false,
    };
  },
  validations() {
  
    return {
      form: {
        folder_id: { required },
        assign_area_name: { required },
        folder_document_type_id: !this.form.type_name_document
          ? { required }
          : {},
        comment: {},
        file: this.currentDocument ? {} : { required },
        is_cubicacion: {},
        type_name_document: {},
        name_document_provisional: this.form.type_name_document
          ? { required }
          : {},
        expiration_date: this.isSelectedDocumentDateValidable
          ? { required }
          : {},
      },
      
    };
    
  },
  methods: {
    ...mapActions({
      uploadDocumentFromPresaleOrProject:
        "document/uploadDocumentFromPresaleOrProject",
      getAllfoldersDocumentsTypes: "document/getAllfoldersDocumentsTypes",
      deleteDocument: "document/deleteDocument",
      updateOrCreateNameDocument: "document/updateOrCreateNameDocument",
      associateNameDocument: "document/associateNameDocument",
      clearFoldersDocumentTypes: "document/clearFoldersDocumentTypes",
      sendUpdateDocument: "document/updateDocument",
    }),
    setFileDonwloadDrive(file) {
      this.form.file = file;
    },
    async openModalFilesDrive() {
      this.$refs.modalFilesGoogleDrive.verifyAndGetGoogleDriveAccessToken();
      this.dialogGoogleDrive = true;
    },
    closeModalFilesGoogleDrive($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.dialogGoogleDrive = false;
      }
    },
    maintainSearchNameDocument() {
      let currentSearch = this.searchNameDocument;
      if (!this.form.folder_document_type_id) {
        
        setTimeout(() => {
          this.searchNameDocument = currentSearch;
        }, 100);
      }
    },
    async searchFoldersDocumentsTypes(
      search = null,
      folderDocumentTypeId = null,
      setFolderDocumentType = false
    ) {
      if (search !== null) {
        this.searchNameDocument = search;
      }
      if (
        (!search && this.form.folder_id) ||
        ((search || typeof search == "string") &&
          !this.form.folder_document_type_id)
      ) {
        clearTimeout(this.debounce);
        let self = this;
        this.debounce = await setTimeout(async function() {
          self.form.folder_document_type_id = null;
          self.loadingFolders = true;
          await self.getAllfoldersDocumentsTypes({
            folder_filter: self.form.folder_id,
            filter: search ? search : undefined,
            project_id: self.isProject ? self.currentProject.id : undefined,
            pre_project_id: self.isPresale
              ? self.$route.query.presale_code
              : undefined,

            items: 100,
          });
          if (setFolderDocumentType) {
            self.form.folder_document_type_id = self.filteredFoldersDocumentsTypes.find(
              (item) => item.name == search
            ).id;
            this.searchNameDocument = null;
          }
          self.loadingFolders = false;
          if (folderDocumentTypeId) {
            self.form.folder_document_type_id = folderDocumentTypeId;
          }
        }, self.debounceTime);
      }
    },
   
    async sendUploadDocument() {
      let self = this;
      self.submitUpload = true;
      if (self.$v.form.$invalid) {
        return;
      }

      self.loading = true;
      try {
        const acceptedFormats = self.isSelectedDocumentCubicacion
          ? self.acceptedCubage
          : self.acceptedFormats;
        if (
          !acceptedFormats.includes(
            `.${self.form.file.name.split(".").pop()}`
          )
        ) {
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: "El formato del archivo no es válido",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }

        const expirationDate = self.form.expiration_date
          ? new Date(self.form.expiration_date).toISOString()
          : null;
        const resp = await self.uploadDocumentFromPresaleOrProject({
          body: {
            created_by: self.user.email,
            comment: self.form.comment,
            project_id: self.isProject ? self.currentProject.id : undefined,
            pre_project_id: self.isPresale
              ? self.$route.query.presale_code
              : undefined,
            expiration_date: expirationDate,
            file_dict: {
              //Reemplaza el signo de + por _
              [self.form.file.name.replace(/\+/g, "_")]: self.form
                .folder_document_type_id,
            },
          },
          files: [
            renameAndReturnNewFile(
              self.form.file,
              self.form.file.name.replace(/\+/g, "_")
            ),
          ],
        });
        if (!resp || !resp.status || resp.status === 400) {
          return swal2.fire({
            icon: "error",
            title: "Error",
            text:
              !resp || !resp.status
                ? "Ha ocurrido un error, intentalo nuevamente"
                : resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        if (resp.status == 200) {
          swal2.fire({
            icon: "success",
            title: "Excelente",
            text: "Documento cargado correctamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          this.$emit("documentCreatedOrUpdated");
          this.closeModalUploadDocument(true);
          this.resetForm();
        }
      } finally {
        self.loading = false;
      }
    },
    async updateDocument() {
      let self = this;
      if (self.form.file) {
        const acceptedFormats = self.isSelectedDocumentCubicacion
          ? self.acceptedCubage
          : self.acceptedFormats;
        if (
          !acceptedFormats.includes(
            `.${self.form.file.name.split(".").pop()}`
          )
        ) {
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: "El formato del archivo no es válido",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
      }

      self.loading = true;
      try {
        let respAction = null;
        if (self.currentDocument && self.form.file) {
          respAction = await self.deleteDocument({
            document_id: self.currentDocument.id,
            user: self.user.email,
          });
        } else {
          respAction = await self.sendUpdateDocument({
            document_id: self.currentDocument.id,
            updated_by: self.user.email,
            comment: self.form.comment,
          });
          swal2.fire({
            icon: "success",
            title: "Excelente",
            text: "Comentario actualizado correctamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          this.$emit("documentCreatedOrUpdated");
          this.closeModalUploadDocument(true);
          this.resetForm();
          return;
        }
        if (respAction && respAction.status == 200) {
          const resp = await self.uploadDocumentFromPresaleOrProject({
            body: {
              created_at: self.currentDocument.created_at,
              created_by: self.user.email,
              comment: self.form.comment,
              project_id: self.isProject ? self.currentProject.id : undefined,
              pre_project_id: self.isPresale
                ? self.$route.query.presale_code
                : undefined,
              file_dict: {
                [self.form.file.name]:
                  self.currentDocument.folder_document_type_id,
              },
            },
            files: [self.form.file],
          });

          if (!resp || !resp.status || resp.status === 400) {
            return swal2.fire({
              icon: "error",
              title: "Error",
              text:
                resp?.data?.detail ||
                "Ha ocurrido un error, intentalo nuevamente",
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 10000,
              timerProgressBar: true,
            });
          }
          if (resp.status == 200) {
            swal2.fire({
              icon: "success",
              title: "Excelente",
              text: "Documento actualizado correctamente",
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 5000,
              timerProgressBar: true,
            });
            this.$emit("documentCreatedOrUpdated");
            this.closeModalUploadDocument(true);
            this.resetForm();
          }
        } else {
          return swal2.fire({
            icon: "error",
            title: "Error",
            text:
              respAction?.data?.detail ||
              "Ha ocurrido un error en el servidor, intenta nuevamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
      } finally {
        self.loading = false;
      }
    },
    async createNameDocumentProvisional() {
      let self = this;
      let resp = null;
      self.submitUpload = true;
      if (!self.$v.form.$invalid) {
        self.loading = true;
        let payload = {
          name: self.form.name_document_provisional,
          assigned_area_id: self.assignedAreas.find(
            (item) => item.name == self.form.assign_area_name
          ).id,
          business_unit_id: self.currentPresale.business_unit.id,
          status: false,
          created_by: self.user.email,
          is_hidden: true,
        };
        resp = await self.updateOrCreateNameDocument(payload);
        if (resp && resp.status == 200) {
          resp = await self.associateNameDocument({
            folder_id: self.foldersFromProjectOrPresale.find(
              (item) => item.name == self.form.folder_id
            ).id,
            document_type_id: resp.data.id,
            is_cubicacion: self.form.is_cubicacion ? true : false,
            required: false,
            is_hidden: true,
            created_by: self.user.email,
          });
          if (resp.status == 200) {
            self.form.folder_document_type_id = resp.data.id;
            await this.sendUploadDocument();
            return;
          }
          if (!resp.status || resp.status === 400) {
            self.loading = false;
            return swal2.fire({
              icon: "error",
              title: "Error",
              text: resp.data.detail,
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 10000,
              timerProgressBar: true,
            });
          }
        }
        if (!resp.status || resp.status === 400) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      }
    },
    executeCloseModalUploadDocument($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.resetForm();
        this.closeModalUploadDocument($event);
      }
    },
    resetForm() {
      this.form = {
        folder_id: null,
        assign_area_name: null,
        folder_document_type_id: null,
        comment: "",
        file: null,
        is_cubicacion: false,
        type_name_document: false,
        name_document_provisional: "",
        expiration_date: null,
      };
      this.disabledDocumentRequired = false;
      this.searchNameDocument = null;
      this.submitUpload = false;
    },
    async setDocumentFromRequired(document) {
      let self = this;
      this.form.assign_area_name = document.document_type.assigned_area.name;
      this.form.folder_id = document.folder_name;
      setTimeout(async () => {
        await self.searchFoldersDocumentsTypes(
          self.form.folder_id,
          document.folder_document_type_id,
          false
        );
      }, 200);
      this.disabledDocumentRequired = true;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      foldersDocumentsTypes: "document/foldersDocumentsTypes",
      assignedAreas: "document/assignedAreas",
      foldersFromProjectOrPresale: "document/foldersFromProjectOrPresale",
      currentProject: "project/currentProject",
      currentPresale: "presale/presale",
    }),
    filteredFoldersDocumentsTypes() {
      return (
        this.foldersDocumentsTypes.items
          .map(function(item) {
            return {
              id: item.id,
              name: item.document_type.name,
              assigned_area: item.document_type.assigned_area,
              required: item.required,
              is_cubicacion: item.is_cubicacion,
              is_date_validable: item.is_date_validable,
            };
          })
          .filter((item) => {
            if (this.form.assign_area_name) {
              if (!this.disabledDocumentRequired) {
                return (
                  item.assigned_area.name == this.form.assign_area_name &&
                  !item.required
                );
              }
              return item.assigned_area.name == this.form.assign_area_name;
            }
            if (!this.disabledDocumentRequired) {
              return !item.required;
            }
            return item;
            // Filtrar los nombres de documentos que esten repetidos dentro del mismo array
          })
          //Eliminar documents types repetidos
          .filter((item, index, self) => {
            return self.findIndex((t) => t.name === item.name) === index;
          })
      );
    },

    isSelectedDocumentCubicacion() {
      // Si estamos actualizando un documento, verificar currentDocument
      if (this.currentDocument) {
        const currentDocumentType = this.foldersDocumentsTypes.items.find(
          (item) => item.id === this.currentDocument.folder_document_type_id
        );
        return currentDocumentType?.is_cubicacion === true && this.form.is_cubicacion === 'cubicacion';
      }
      // Si estamos creando un nuevo documento, verificar el seleccionado
      if (this.form.is_cubicacion) {
        return true;
      }
      if (!this.form.folder_document_type_id) {
        return false;
      }
      const selectedDocument = this.foldersDocumentsTypes.items.find(
        (item) => item.id === this.form.folder_document_type_id
      );
      return selectedDocument?.is_cubicacion === true;
    },
    isSelectedDocumentDateValidable() {
      if (!this.form.folder_document_type_id) return false;
      const selectedDocument = this.foldersDocumentsTypes.items.find(
        (item) => item.id === this.form.folder_document_type_id
      );
      return selectedDocument?.is_date_validable === true;
    },
    acceptedFormatsForDocument() {
      return this.isSelectedDocumentCubicacion
        ? this.acceptedCubage
        : this.acceptedFormats;
    },
  },
  watch: {
    currentDocument(document) {
      
      if (document) {
        this.form.comment = document.comment;
      } else {
        this.resetForm();
      }
      this.loading = false;
    },
    "form.type_name_document": function(val) {
      this.form.is_cubicacion = val === "cubicacion";
    },
  },
};
</script>

<style>
.v-input--switch:not(.v-input--switch--flat):not(.v-input--switch--inset)
  .v-input--switch__thumb {
  color: green;
}

.theme--light.v-input--switch .v-input--switch__track {
  color: green;
}
</style>